// src/Obfuscate.tsx
import {
  createElement,
  forwardRef,
  useCallback,
  useMemo,
  useState
} from "react";

// src/util.ts
var noop = () => {
};
var reverse = (content) => content.split("").reverse().map((s) => {
  if (s === "(")
    return ")";
  if (s === ")")
    return "(";
  if (s === "[")
    return "]";
  if (s === "]")
    return "[";
  if (s === "{")
    return "}";
  if (s === "}")
    return "{";
  if (s === "<")
    return ">";
  if (s === ">")
    return "<";
  return s;
}).join("");
var isString = (s) => typeof s === "string";
var createUri = ({ email, tel, sms, href, children }) => {
  if (email) {
    if (isString(email))
      return `mailto:${email}`;
    if (children)
      return `mailto:${children}`;
  }
  if (tel) {
    if (isString(tel))
      return `tel:${tel.replace(/\s/g, "")}`;
    if (children)
      return `tel:${children.replace(/\s/g, "")}`;
  }
  if (sms) {
    if (isString(sms))
      return `sms:${sms.replace(/\s/g, "")}`;
    if (children)
      return `sms:${children.replace(/\s/g, "")}`;
  }
  if (href)
    return href;
  return void 0;
};

// src/Obfuscate.tsx
var Obfuscate = forwardRef(function Obfuscate2({
  as = "a",
  email,
  tel,
  sms,
  href,
  children,
  "aria-label": ariaLabel = "focus to reveal obfuscated content",
  obfuscateText = "obfuscated",
  style,
  onClick = noop,
  onFocus = noop,
  onMouseOver = noop,
  onContextMenu = noop,
  ...rest
}, ref) {
  const [humanInteraction, setHumanInteraction] = useState(false);
  const componentStyle = useMemo(
    () => ({
      ...style,
      unicodeBidi: "bidi-override",
      direction: humanInteraction ? "ltr" : "rtl"
    }),
    [style, humanInteraction]
  );
  const content = useMemo(() => {
    if (children)
      return children;
    if (isString(email))
      return email;
    if (isString(tel))
      return tel;
    if (isString(sms))
      return sms;
    if (isString(href))
      return href;
    return "";
  }, [children, email, tel, sms, href]);
  const uri = useMemo(() => createUri({ email, tel, sms, href, children }), [email, tel, sms, href, children]);
  const hrefUri = useMemo(() => humanInteraction ? uri : obfuscateText, [humanInteraction, uri, obfuscateText]);
  const handleOnClick = useCallback(
    (e) => {
      onClick(e);
      if (!humanInteraction && uri) {
        window.location.href = uri;
      }
    },
    [humanInteraction, uri, onClick]
  );
  const handleOnFocus = useCallback(
    (e) => {
      onFocus(e);
      setHumanInteraction(true);
    },
    [onFocus]
  );
  const handleOnMouseOver = useCallback(
    (e) => {
      onMouseOver(e);
      setHumanInteraction(true);
    },
    [onMouseOver]
  );
  const handleOnContextMenu = useCallback(
    (e) => {
      onContextMenu(e);
      setHumanInteraction(true);
    },
    [onContextMenu]
  );
  return createElement(
    as,
    {
      style: componentStyle,
      href: uri ? hrefUri : void 0,
      "aria-label": humanInteraction ? void 0 : ariaLabel,
      onClick: handleOnClick,
      onFocus: handleOnFocus,
      onMouseOver: handleOnMouseOver,
      onContextMenu: handleOnContextMenu,
      ...rest,
      ref
    },
    humanInteraction ? content : reverse(content)
  );
});
export {
  Obfuscate
};
//# sourceMappingURL=index.esm.js.map